import { PERMISSION_ROLES } from './permissionRoles';
import { PERMISSIONS_MAP } from './permissionsMap';

/**
 * Mapping of user role codes to the list of permission keys available to each role.
 *
 * Each property key is a role code (from {@link PERMISSION_ROLES}), and its value is an array of permission
 * strings that the role grants access to. Built dynamically from {@link PERMISSIONS_MAP}.
 *
 * This map is useful for quickly determining what permissions are granted to a particular role.
 *
 * @readonly
 * @type {Object.<number, string[]>}
 *
 * @example
 * // Get all permissions for the Account Administrator role:
 * const adminPermissions = PERMISSIONS_BY_ROLES[PERMISSION_ROLES.ACCOUNT_ADMINISTRATOR];
 * if (adminPermissions.includes('MANAGE_USERS')) {
 *   // Account administrator can manage users
 * }
 */
export const PERMISSIONS_BY_ROLES = Object.values(PERMISSION_ROLES).reduce((acc, role) => {
    acc[role] = Object.entries(PERMISSIONS_MAP)
        .filter(([, roles]) => roles.includes(role))
        .map(([permission]) => permission);

    return acc;
}, {});
